import { useTranslation } from "react-i18next";
import { Button, Icon, Modal } from "semantic-ui-react";

import "modules/DealersDashboard/components/DealerInfoModal/DealerInfoModal.scss";

import type { Dealer } from "models";

type DealerInfoModalProps = {
  dealer: Dealer | null;
  onClose: () => void;
};

export const DealerInfoModal = ({ dealer, onClose }: DealerInfoModalProps) => {
  const { t } = useTranslation();

  if (!dealer) return null;

  const rows = [
    { label: t("v8_dealer", "Dealer"), value: dealer.name },
    { label: "ID", value: `${dealer.id}` },
    { label: t("v8_system_admin_name", "Admin"), value: dealer.sys_admin_name },
    { label: t("v8_system_admin_email", "Admin e-mail"), value: dealer.sys_admin_email },
    { label: t("v8_phone", "Phone"), value: dealer.sys_admin_phone },
    { label: t("v8_dms_server_information", "DMS Info"), value: dealer.dms_server_info },
    { label: t("v8_network_info", "Network Info"), value: dealer.network_info }
  ];

  return (
    <Modal open size="tiny" closeOnDimmerClick={false} onClose={onClose} className="DealerInfoModal">
      <Modal.Header>
        <div>{t("v8_dealer_info", "Dealer Info")}</div>
        <Button className="modal-close-btn" basic onClick={onClose}>
          <Icon className="xmark" />
        </Button>
      </Modal.Header>

      <Modal.Content>
        {rows.map(({ label, value }) => (
          <div className="row" key={label}>
            <span>{label}</span>
            <span>{value}</span>
          </div>
        ))}
      </Modal.Content>
    </Modal>
  );
};
